import { FC, Fragment } from 'react';
import { isEmpty } from 'radash';
import { ICategoryMenu, ICategoryMenuDetail } from '@modules/header/domain/models/menu.model';
import CategoryMenuSkeleton from '@components/skeleton/categoryMenu/CategoryMenu';
import { analytics } from '@shared/utils/segment.utils';
import { CategoryMenuLayoutContainer, CategoryTitle, CloseIcon, MenuWrapper, SubCategoryMenuContainer, SubMenuButton, Wrapper } from './CategoryMenu.style';
interface Props {
  data: ICategoryMenu;
  isCategoryOpen: boolean;
  setCloseCategory: () => void;
}
const CategoryMenuLayout: FC<Props> = ({
  data,
  isCategoryOpen,
  setCloseCategory
}: Props) => {
  const ContainerAnimation = {
    open: {
      opacity: 1,
      y: 0,
      display: 'block'
    },
    closed: {
      opacity: 0,
      y: 20,
      transitionEnd: {
        display: 'none'
      }
    }
  };
  const onClickCloseButton = () => {
    setCloseCategory();
    analytics.track('Sub Navigation Close', {
      event: 'Sub Navigation Close',
      close_by: 'close button'
    });
  };
  const renderSubMenu = () => {
    return Object.values(data).map((subMenu: ICategoryMenuDetail) => {
      return <div key={subMenu.id}>
                    <CategoryTitle onClick={() => analytics.track('Sub Navigation Main Category Click', {
          event: 'Sub Navigation Main Category Click'
        })}>
                        {subMenu.title}
                    </CategoryTitle>
                    <MenuWrapper>
                        {isEmpty(subMenu.menuList) ? <Fragment>
                                <CategoryMenuSkeleton />
                                <CategoryMenuSkeleton />
                                <CategoryMenuSkeleton />
                                <CategoryMenuSkeleton />
                                <CategoryMenuSkeleton />
                            </Fragment> : subMenu.menuList.map(item => <SubCategoryMenuContainer key={item.id} onClick={() => analytics.track('Sub Navigation Sub Category Click', {
            event: 'Sub Navigation Sub Category Click',
            submenu: item.title
          })}>
                                    <span>•</span>
                                    <a href={item.linkOut} aria-label={item.title}>
                                        {item.title}
                                    </a>
                                </SubCategoryMenuContainer>)}
                    </MenuWrapper>
                </div>;
    });
  };
  return <CategoryMenuLayoutContainer variants={ContainerAnimation} animate={isCategoryOpen ? 'open' : 'closed'} initial={false}>
            <CloseIcon src="/icons/x.svg" alt="Close icon" onClick={() => onClickCloseButton()} width={18} height={18} />
            <Wrapper>{renderSubMenu()}</Wrapper>
            <a href="/recipe" aria-label="recipe">
                <SubMenuButton onClick={() => analytics.track('Sub Navigation All Menu Click', {
        event: 'Sub Navigation All Menu Click'
      })}>
                    ดูเมนูทั้งหมด
                </SubMenuButton>
            </a>
        </CategoryMenuLayoutContainer>;
};
export default CategoryMenuLayout;